import React from "react";
// import Carousel from "react-elastic-carousel";
import URL from "../Assets/url.jpg";

const Project = () => {
  return (
    <div id="project" className="project-wraper">
      <h1 className="project-header">Projects</h1>
      <div className="project_cards">
        <div className="project-card1 rounded-top">
          <h1>E-Commerce Store</h1>
          <img
            src="https://froggyads.com/blog/wp-content/uploads/2020/05/Understanding-E-Commerce-Types-and-Examples.jpg"
            alt="proj img"
          />
          <p>
            {" "}
            A Prototype of E-Commerce Website with features of login, Add to
            Cart, Stock check, Checkout.
          </p>
          <div className="card_btns">
            <a
              href="https://ecommerce-site-v2.netlify.app"
              target="_blank"
              rel="noreferrer"
              className="project-btn1"
            >
              Demo
            </a>
            <a
              href="https://github.com/prathu0603/ECommerce-frontEnd"
              target="_blank"
              rel="noreferrer"
              className="project-btn2"
            >
              Github
            </a>
          </div>
        </div>

        <div className="project-card1 rounded-top">
          <h1>E-Library</h1>
          <img
            src="https://thumbs.dreamstime.com/b/web-page-template-digital-library-banner-electronic-people-characters-vector-illustration-pass-online-courses-read-books-162679711.jpg"
            alt="proj img"
          />
          <p>
            An online library to search books by category and download them.
            Admin can add books.
          </p>
          <div className="card_btns">
            <a
              href="https://open-library-v1.netlify.app"
              target="_blank"
              rel="noreferrer"
              className="project-btn1"
            >
              Demo
            </a>
            <a
              href="https://github.com/prathu0603/open-library-client"
              target="_blank"
              rel="noreferrer"
              className="project-btn2"
            >
              Github
            </a>
          </div>
        </div>
        <div className="project-card1 rounded-top">
          <h1>Open Chats</h1>
          <img
            src="https://static.vecteezy.com/system/resources/previews/002/196/440/original/open-chat-logo-template-use-door-symbol-this-design-suitable-for-forum-discuss-and-dialogue-vector.jpg"
            alt="proj img"
          />
          <p>
            Open chats have multiple open groups to join and chat or create your
            own to chat with anonymous persons.
          </p>
          <div className="card_btns">
            <a
              href="https://chat-box-v1.netlify.app"
              target="_blank"
              rel="noreferrer"
              className="project-btn1"
            >
              Demo
            </a>
            <a
              href="https://github.com/prathu0603/chat-box"
              target="_blank"
              rel="noreferrer"
              className="project-btn2"
            >
              Github
            </a>
          </div>
        </div>
        <div className="project-card1 rounded-top">
          <h1>Blog Media</h1>
          <img
            src="https://socialmediaweek.org/wp-content/blogs.dir/1/files/brand-blog-feature.jpg"
            alt="proj img"
          />
          <p>
            {" "}
            A perfect media to share personal, travelling, biography,
            historical, etc types of Blog.
          </p>
          <div className="card_btns">
            <a
              href="https://blogemon-v1.netlify.app"
              target="_blank"
              rel="noreferrer"
              className="project-btn1"
            >
              Demo
            </a>
            <a
              href="https://github.com/prathu0603/blog-frontEnd"
              target="_blank"
              rel="noreferrer"
              className="project-btn2"
            >
              Github
            </a>
          </div>
        </div>
        <div className="project-card1 rounded-top">
          <h1>URL Shortener</h1>
          <img src={URL} alt="project img" />
          <p>
            URL Shortener is used to reduce a long link. So the short url can be
            used for Promotions Easily.
          </p>
          <div className="card_btns">
            <a
              href="https://url-shortner-client.netlify.app"
              target="_blank"
              rel="noreferrer"
              className="project-btn1"
            >
              Demo
            </a>
            <a
              href="https://github.com/prathu0603/url-shortner-client"
              target="_blank"
              rel="noreferrer"
              className="project-btn2"
            >
              Github
            </a>
          </div>
        </div>

        <div className="project-card1 rounded-top">
          <h1>G-Drive Clone</h1>
          <img
            src="https://i.pcmag.com/imagery/lineups/04paueUFPZ38gBo5HRX3Vfv-1.1569492723.fit_lim.size_1200x630.jpg"
            alt="project img"
          />
          <p>
            G-Drive is cloud storage system which allow users to store files in
            the cloud & synchronize files across devices.
          </p>
          <div className="card_btns">
            <a
              href="https://g-drive-clone-v1.netlify.app"
              target="_blank"
              rel="noreferrer"
              className="project-btn1"
            >
              Demo
            </a>
            <a
              href="https://github.com/prathu0603/g-drive-clone"
              target="_blank"
              rel="noreferrer"
              className="project-btn2"
            >
              Github
            </a>
          </div>
        </div>

        <div className="project-card1 rounded-top">
          <h1>Movie App</h1>
          <img
            src="https://www.wallpaperup.com/uploads/wallpapers/2015/12/12/859126/5b431ce5733d1553d3b7bf0efc11412e-700.jpg"
            alt="project img"
          />
          <p>
            An app to explore popular and latest movies with details and feature
            of favourite list.
          </p>
          <div className="card_btns">
            <a
              href="https://capital-movies-v1.netlify.app"
              target="_blank"
              rel="noreferrer"
              className="project-btn1"
            >
              Demo
            </a>
            <a
              href="https://github.com/prathu0603/movie-app"
              target="_blank"
              rel="noreferrer"
              className="project-btn2"
            >
              Github
            </a>
          </div>
        </div>
      </div>
      {/* <Carousel
        enableAutoPlay
        autoPlaySpeed={50000}
        easing="cubic-bezier(1,.15,.55,1.54)"
        tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)"
        transitionMs={700}
        itemsToShow={1}
      >
        <div className="project-card rounded-top">
          <h1>URL Shortener</h1>
          <img src={URL} alt="project img" />
          <p>
            URL Shortener is used to reduce a long link. So the short url can be
            used for Promotions Easily.
          </p>
          <a
            href="https://url-shortner-client.netlify.app"
            target="_blank"
            rel="noreferrer"
            className="project-btn"
          >
            Demo
          </a>
        </div>
        <div className="project-card rounded-top">
          <h1>E-Library</h1>
          <img
            src="https://thumbs.dreamstime.com/b/web-page-template-digital-library-banner-electronic-people-characters-vector-illustration-pass-online-courses-read-books-162679711.jpg"
            alt="proj img"
          />
          <p>
            The colletion of different books available which can be downloaded.
          </p>
          <a
            href="https://open-library-v1.netlify.app"
            target="_blank"
            rel="noreferrer"
            className="project-btn"
          >
            Demo
          </a>
        </div>
        <div className="project-card rounded-top">
          <h1>Open Chats</h1>
          <img
            src="https://static.vecteezy.com/system/resources/previews/002/196/440/original/open-chat-logo-template-use-door-symbol-this-design-suitable-for-forum-discuss-and-dialogue-vector.jpg"
            alt="proj img"
          />
          <p>
            A messenger with open groups to which anyone could join and chat.
          </p>
          <a
            href="https://chat-box-v1.netlify.app"
            target="_blank"
            rel="noreferrer"
            className="project-btn"
          >
            Demo
          </a>
        </div>
        <div className="project-card rounded-top">
          <h1>Blog Media</h1>
          <img
            src="https://socialmediaweek.org/wp-content/blogs.dir/1/files/brand-blog-feature.jpg"
            alt="proj img"
          />
          <p>The place where you could share & store memories you captured.</p>
          <a
            href="https://blogemon-v1.netlify.app"
            target="_blank"
            rel="noreferrer"
            className="project-btn"
          >
            Demo
          </a>
        </div>
        <div className="project-card rounded-top">
          <h1>E-Commerce Store</h1>
          <img
            src="https://froggyads.com/blog/wp-content/uploads/2020/05/Understanding-E-Commerce-Types-and-Examples.jpg"
            alt="proj img"
          />
          <p>A Prototype of E-Commerce websites with cart feature.</p>
          <a
            href="https://ecommerce-site-v1.netlify.app"
            target="_blank"
            rel="noreferrer"
            className="project-btn"
          >
            Demo
          </a>
        </div>
      </Carousel> */}
    </div>
  );
};

export default Project;
